<template>
  <div class="row product-view-photos" v-if="photos">
    <div class="col-2">
      <div class="photo-thumb" v-for=" photo in photos">
        <img :src="photo.view" class="img-fluid" @click="select(photo.view)">
      </div>
    </div>
    <div class="col-10 gallery-big-image" @click="showModalView">
      <img v-if="selected" :src="selected" class="img-fluid big-image">
      <img v-else :src="photos[0].view" class="img-fluid big-image">
    </div>

    <modal v-if="showModal" @close="showModal = false">
      <div slot="body" :key="selected">
        <croppa
          id="croppa"
          v-model="myCroppa"
          :width="400"
          :height="400"
          :quality="2"
          :zoom-speed="5"
          :disabled="false"
          :disable-drag-and-drop="true"
          :disable-click-to-choose="true"
          :disable-drag-to-move="false"
          :disable-scroll-to-zoom="false"
          :disable-rotation="false"
          :prevent-white-space="false"
          :reverse-scroll-to-zoom="false"
          :show-remove-button="false"
          :initial-image="selected"
        ></croppa>
      </div>
      <div slot="header">
        <div class="row modal-row">
          <div class="col-md-8 col-md-pull-4 col-sm-8 col-sm-pull-4">
            <h3>Wybrane Zdjęcie</h3>
          </div>
          <div class="col-md-4 col-md-push-9 col-sm-4 col-sm-push-8 close-col">
            <button @click="showModal = false" class="close-button"></button>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="photos-row">
          <div class="photo-thumb" v-for=" photo in photos">
            <img :src="photo.view" class="photo-row-element" @click="select(photo.view)">
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "../../product/PictureModalView.vue";

export default {
  components: { Modal },
  props: ["photos"],
  data() {
    return {
      selected: this.photos[0].view,
      myCroppa: {},
      showModal: false
    };
  },
  methods: {
    showModalView() {
      this.showModal = true;
    },
    select(img) {
      this.selected = img;
      this.$emit("selectedImg", img);
    }
  }
};
</script>
<style>
.pic-box {
  width: 500px;
  height: 500px;
}
.gallery-big-image {
  cursor: zoom-in;
}
</style>




// WEBPACK FOOTER //
// src/components/products/src/productPage/elements/Gallery.vue